var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 128 160",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 168") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M118,12H10A10,10,0,0,0,0,22v84a10,10,0,0,0,10,10H118a10,10,0,0,0,10-10V22A10,10,0,0,0,118,12ZM10,16H118a6,6,0,0,1,6,6V36H4V22A6,6,0,0,1,10,16Zm108,96H10a6,6,0,0,1-6-6V40H124v66A6,6,0,0,1,118,112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M58,28h56a2,2,0,0,0,0-4H58a2,2,0,0,0,0,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M83.41,59.59a2,2,0,0,0-2.82,2.82L95.17,77,80.59,91.59a2,2,0,1,0,2.82,2.82l16-16a2,2,0,0,0,0-2.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M47.41,59.59a2,2,0,0,0-2.82,0l-16,16a2,2,0,0,0,0,2.82l16,16a2,2,0,0,0,2.82-2.82L32.83,77,47.41,62.41A2,2,0,0,0,47.41,59.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M68.39,56A2,2,0,0,0,66,57.61l-8,40A2,2,0,0,0,59.61,100a1.72,1.72,0,0,0,.39,0,2,2,0,0,0,2-1.61l8-40A2,2,0,0,0,68.39,56Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 14,
    cy: 26,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 26,
    cy: 26,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 38,
    cy: 26,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/web_development.bb00130a8a51a72b57ecc97a80b345bf.svg";
export { ForwardRef as ReactComponent };